import { useState, useCallback } from 'react';
import { useAppDispatch } from '../../store/store';
import { shareProject } from '../../shared/api/textProjectApi';
import { useSelector } from 'react-redux';
import {
    selectCurrentProject,
    selectIsLoadingSharing,
    selectPostsToPublish,
} from '../../store/selectors/projectSelectors';
import { setPostSuccess } from '../../store/slices/projectSlice';
import { toast } from 'react-toastify';

interface usePostProjectProjectReturn {
    isPosted: boolean;
    setIsPosted: (value: boolean) => void;
    postProject: () => Promise<void>;
}

export function usePostProject(): usePostProjectProjectReturn {
    const dispatch = useAppDispatch();
    const [isPosted, setIsPosted] = useState(false);
    const project = useSelector(selectCurrentProject);
    const isLoadingShare = useSelector(selectIsLoadingSharing);
    const postsToPublish = useSelector(selectPostsToPublish);

    const postProject = useCallback(async () => {
        if (postsToPublish && postsToPublish.length > 0) {
            for (const post of postsToPublish) {
                if (!post?.id) {
                    continue;
                }

                const result = await dispatch(shareProject({ projectId: post.id }));
                if (result?.meta.requestStatus === 'fulfilled') {
                    setIsPosted(true);
                    dispatch(setPostSuccess(true));
                } else {
                    toast.error('Error publishing post');
                }
            }

            return;
        }

        if (!project?.id || isLoadingShare) return;

        const result = await dispatch(shareProject({ projectId: project.id }));
        console.log('result', result);
        if (result?.meta.requestStatus === 'fulfilled') {
            setIsPosted(true);
            dispatch(setPostSuccess(true));
        } else {
            toast.error('Error publishing post');
        }
    }, [dispatch, project, postsToPublish, isLoadingShare]);

    return { isPosted, setIsPosted, postProject };
}
